import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'


const Id6 = () => {

    const detail = 
        {
            id:6,
            imgSrc:'/news/fasciola_250701/cover.jpg',
            ini:'Hands-on training program about application of duplex PCR for species identification of <i>Fasciola</i> spp.',
            href:'',
            element:'',
            topic:'',
            inform:`During 1–30 July 2025, Mrs. Phengsavanh Xaiyavong, a research assistant from IRD, Lao People's Democratic Republic, participated in a hands-on training program at LUCENT International Collaboration, Faculty of Associated Medical Sciences, Chiang Mai University, focusing on the application of duplex PCR for species identification of <i>Fasciola</i> spp. This training was conducted to support the ongoing research project titled “A One-Health approach to estimate the prevalence of helminth infections in elephants, domesticated bovines, and human population living at the edge of the Nakai-Nam Theun National Park, Lao People's Democratic Republic” and aimed to strengthen molecular diagnostic skills for differentiating <i>Fasciola giantica</i> and <i>Fasciola hepatica</i> in human and animal samples, which is essential for epidemiological investigations. The training consisted of theoretical sessions, laboratory practice, and data analysis, with a strong emphasis on hands-on experience. During the training, the participant was given the opportunity to actively engage in all laboratory steps, including PCR setup and optimization, and result interpretation.`,
       }
    

    const imgs = [
        {
            imageSrc: '/news/fasciola_250701/cover.jpg',
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: '/news/fasciola_250701/cover.jpg'
        },
        {
            imageSrc: '/news/fasciola_250701/pic1.jpg',
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: '/news/fasciola_250701/pic1.jpg'
        }
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{Parse(detail.ini)}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
            </div>
        </div>
    );
}

export default Id6;
